import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@sabre/aven-spark';
import classNames from 'classnames';
import ReactDom from 'react-dom';

/**
 * A Spark Tooltip High Order Function, that returns a High Order Component wrapping the passed Component.
 * Parameters:
 * @param {string}  tooltipContent - Text/HTML to be displayed as Tooltip of the wrapped component
 * @param {string}  tooltipPosition - Position of the tooltip, has to be one of 'top', 'bottom', 'left' or 'right'
 */
export default function(tooltipContent, tooltipPosition) {
    /**
     * Standard High Order Component pattern
     *
     * @param {Component} WrappedComponent - Component to wrap adding tooltip CSS class and necessary children
     */
    return WrappedComponent => {
        return class extends Component {
            static propTypes = {
                /** Child nodes this wrapped component. */
                children: PropTypes.node,
                /** Any extra CSS classes for the component */
                className: PropTypes.string
            };

            constructor() {
                super();
                if (['top', 'bottom', 'left', 'right'].indexOf(tooltipPosition) > -1) {
                    this.tooltipPosition = tooltipPosition;
                } else {
                    // This ensures a default value if tooltipPosition is undefined or incorrectly passed
                    this.tooltipPosition = 'right';
                }
                this.tooltipText = tooltipContent;
                this._getExtraChild = this._getExtraChild.bind(this);
            }

            componentDidMount() {
                this.tooltip = new Tooltip(ReactDom.findDOMNode(this.wrappedComponent));
            }

            componentWillUnmount() {
                this.tooltip = undefined;
            }

            _getExtraChild() {
                return (
                    <span className={'spark-tooltip__content--' + this.tooltipPosition} role="tooltip">
                        {this.tooltipText}
                        <span className="spark-tooltip__caret"></span>
                    </span>
                );
            }

            render() {
                const { children, className, ...passThroughProps } = this.props;
                const wrappedComponentClass = classNames(className, 'spark-tooltip');

                return (
                    <WrappedComponent
                        ref={c => (this.wrappedComponent = c)}
                        className={wrappedComponentClass}
                        {...passThroughProps}
                    >
                        {children}
                        {this._getExtraChild()}
                    </WrappedComponent>
                );
            }
        };
    };
}



// WEBPACK FOOTER //
// ./src/components/ui/sabre-spark-react-ex/tooltip/index.js